import { render } from "./MainDrawer.vue?vue&type=template&id=9b297d42"
import script from "./MainDrawer.vue?vue&type=script&lang=js"
export * from "./MainDrawer.vue?vue&type=script&lang=js"

import "./MainDrawer.vue?vue&type=style&index=0&id=9b297d42&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.3.0_webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__